<div class="panel panel-plan min-height">

	@if (isFormVisible) {
	<div class="px-4">

		@if (isSetupVisible) {
		<form [formGroup]="form!">
			<div class="d-flex align-items-center mb-5">
				<h3 data-testid="SUBSYS2_PLANFORM_SETUP_MSG_TXT" class="m-0 me-5">
					{{ labels().PLAN_FORM_COMPONENT_SETUP_MSG }} &nbsp; *
				</h3>
				<div class="btn-group ms-5" aria-label="Setup button group">
					<input type="radio" class="btn-check" name="withImages" id="setup1" autocomplete="off"
						formControlName="withImages" [value]="true"
						[class]="{'is-invalid': form!.controls.withImages.invalid && form!.controls.withImages.touched}"
						[attr.disabled]="isReadonly ? true : null">
					<label data-testid="SUBSYS2_PLANFORM_SETUP_XRAY_BTN" class="btn btn-outline py-2 m-0" for="setup1">
						{{ labels().PLAN_FORM_COMPONENT_SETUP_XRAYS }}
					</label>
					<input type="radio" class="btn-check" name="withImages" id="setup2" autocomplete="off"
						formControlName="withImages" [value]="false"
						[class]="{'is-invalid': form!.controls.withImages.invalid && form!.controls.withImages.touched}"
						[attr.disabled]="isReadonly ? true : null">
					<label data-testid="SUBSYS2_PLANFORM_SETUP_NOXRAY_BTN" class="btn btn-outline py-2 m-0" for="setup2">
						{{ labels().PLAN_FORM_COMPONENT_SETUP_NOIMAGES }}
					</label>
				</div>
			</div>
		</form>
		}

		<div class="row">
			<div class="col-3" [class.m-auto]="setupValue == false">
				<plan-bone />
			</div>
			@if (setupValue != false) {
			<div class="col-9">
				<plan-image />
			</div>
			}
		</div>

	</div>
	}

</div>